"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_router_1 = require("react-router");
const react_router_dom_1 = require("react-router-dom");
const URLs_1 = require("../utility/URLs");
const helpers_1 = require("../../commonFiles/helpers");
const URLs_2 = require("../utility/URLs");
const PagesTable_1 = __importDefault(require("../components/PagesTable"));
const react_router_dom_2 = require("react-router-dom");
const ChangePageTitle_1 = __importDefault(require("../../commonFiles/ChangePageTitle"));
const Paginator_1 = __importDefault(require("../../commonFiles/Paginator"));
const Filters_1 = require("../components/Filters");
function Chapter(props) {
    var _a;
    const chapter = props.chapter;
    return react_1.default.createElement(react_bootstrap_1.ListGroup, { as: "ol", numbered: true },
        react_1.default.createElement("div", null, chapter === null || chapter === void 0 ? void 0 : chapter.title), (_a = chapter === null || chapter === void 0 ? void 0 : chapter.sections) === null || _a === void 0 ? void 0 :
        _a.map((element, index) => {
            if (element.type == 'section')
                return react_1.default.createElement(Section, { key: index, section: element });
            else if (element.type == 'chapter')
                return react_1.default.createElement(Chapter, { key: index, chapter: element });
        }));
}
function Section(props) {
    const section = props.section;
    return react_1.default.createElement(react_bootstrap_1.ListGroup.Item, { as: "li" },
        react_1.default.createElement(react_router_dom_1.Link, { to: URLs_2.Routes.pageShow(section.page_id) }, section.title));
}
function BookShow(props) {
    const { id } = (0, react_router_1.useParams)();
    const [book, setbook] = react_1.default.useState(null);
    function fetchBook() {
        (0, helpers_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () { return yield URLs_1.Api.fetchBook(id, {}); }), setbook, 'BookShow fetchBook', true);
    }
    const history = (0, react_router_dom_2.useHistory)();
    react_1.default.useEffect(() => {
        fetchBook();
    }, []);
    const [pagesPagination, setpagesPagination] = react_1.default.useState();
    function fetch(params) {
        return URLs_1.Api.fetchPages(Object.assign(Object.assign(Object.assign({}, (0, Filters_1.getPaginationParams)(pagesPagination)), { book_id: id, page_size: 10 }), params));
    }
    return react_1.default.createElement("div", { className: "bg-white rounded shadow p-2" },
        react_1.default.createElement(ChangePageTitle_1.default, { pageTitle: 'عرض: ' + (book === null || book === void 0 ? void 0 : book.title) }),
        react_1.default.createElement("div", { className: "d-flex justify-content-end" },
            react_1.default.createElement(react_router_dom_1.Link, { to: URLs_2.Routes.bookEdit(book === null || book === void 0 ? void 0 : book.id), className: "mr-auto btn btn-success text-white d-flex " },
                react_1.default.createElement("i", { className: "bi bi-pencil-square mx-2" }),
                react_1.default.createElement("div", null, "\u062A\u0639\u062F\u064A\u0644"))),
        react_1.default.createElement("h1", { className: 'text-center' }, book === null || book === void 0 ? void 0 : book.title),
        react_1.default.createElement("div", { className: "border rounded my-2" },
            react_1.default.createElement("div", { className: "fw-bold" }, "\u062D\u0648\u0644 \u0627\u0644\u0643\u062A\u0627\u0628"),
            react_1.default.createElement("div", null, book === null || book === void 0 ? void 0 : book.about)),
        react_1.default.createElement("div", { className: "border rounded my-2" },
            react_1.default.createElement("div", { className: "fw-bold" }, "\u0648\u0635\u0641 \u0627\u0644\u0643\u062A\u0627\u0628 \"\u064A\u0639\u0631\u0636 \u0644\u0644\u0645\u062A\u0635\u0641\u062D\u064A\u0646\""),
            react_1.default.createElement("div", null, book === null || book === void 0 ? void 0 : book.description)),
        react_1.default.createElement("div", { className: "border rounded my-2" },
            react_1.default.createElement("div", { className: "fw-bold" }, "\u0639\u0631\u0636 \u0627\u0644\u0643\u062A\u0627\u0628"),
            react_1.default.createElement("div", null, (book === null || book === void 0 ? void 0 : book.activated) ? 'مفعل' : 'غير مفعل')),
        react_1.default.createElement("h3", { className: 'text-center' }, "\u062C\u062F\u0648\u0644 \u0627\u0644\u0645\u062D\u062A\u0648\u0649"),
        react_1.default.createElement(react_bootstrap_1.Col, { xs: 8, className: 'mx-auto' },
            react_1.default.createElement(react_bootstrap_1.ListGroup, { as: "ol" }, book === null || book === void 0 ? void 0 : book.content_table.map((element, index) => {
                if (element.type == 'chapter')
                    return react_1.default.createElement(Chapter, { chapter: element, key: index });
                else
                    return react_1.default.createElement(Section, { section: element, key: index });
            }))),
        react_1.default.createElement("h3", { className: 'text-center' }, "\u0635\u0641\u062D\u0627\u062A \u062A\u0634\u064A\u0631 \u0644\u0644\u0643\u062A\u0627\u0628"),
        react_1.default.createElement("div", null,
            react_1.default.createElement(PagesTable_1.default, { pages: pagesPagination === null || pagesPagination === void 0 ? void 0 : pagesPagination.data })),
        react_1.default.createElement(Paginator_1.default, { log: 'FETCH pages', apiCall: fetch, useState: [pagesPagination, setpagesPagination] }));
}
exports.default = BookShow;
